import type { Action } from 'redesign/components/organisms/action-wrapper/types'
import type { ResolveActionButtonsProps } from '../../task-details-action-buttons/types'
import getFrontlineActionButtons from './frontline-action-buttons'
import { getOfficeActionButtons } from './get-office-action-buttons'

export const getMonthlySheetActionButtons = (props: ResolveActionButtonsProps): Action[] => {
  const { isOffice } = props

  if (isOffice) {
    return getOfficeActionButtons(props)
  }

  return getFrontlineActionButtons(props)
}
